export default {
  dealer_zone: null,
  dealer_zones: [],
};
